
import React from "react";
import NaBar from "../components/NavBar";
import HeroImg from "../components/HeroImg";
import Footer from "../components/Footer";



const Home = () => {
    return (
        <div>
             <NaBar/>
             <HeroImg/>
             <Footer/>
        </div>
       
      );
}

export default Home